// SectionFade.tsx
import { Box, Fade } from '@mui/material';
import React from 'react';
import { useRef, useState, useEffect } from 'react';
export default function SectionFade({ children, threshold = 0.35, // tweak when the fade starts
bgcolor, }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), { threshold });
        if (ref.current)
            observer.observe(ref.current);
        return () => observer.disconnect();
    }, [threshold]);
    return (React.createElement(Box, { ref: ref, sx: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor,
        } },
        React.createElement(Fade, { in: visible, timeout: 800 },
            React.createElement(Box, { sx: { width: '100%' } }, children))));
}
